
import * as ar from './ar'
import * as en from './en'

const langs = {en,ar}
let lang = langs.en

const setDefaultLang = (lg)=>lang = langs[lg]


export {lang, setDefaultLang}



// WEBPACK FOOTER //
// ./src/lang/index.js